<template lang="pug">
modal(name='saveDialog' height='auto' :classes="['v--modal', 'vue-dialog', this.params.class]" :width='width' :pivot-y='0.3' :adaptive='true' :clickToClose="clickToClose" :transition='transition' @before-open='beforeOpened' @before-close='beforeClosed' @opened="$emit('opened', $event)" @closed="$emit('closed', $event)")
  .dialog-content
    .dialog-c-title(v-if='params.title' v-html="params.title || ''")
    component(v-if='params.component' v-bind='params.props' :is='params.component')
    .dialog-c-text
      div.input#saveDialog(contenteditable v-tooltip="'Set the title for your shared model'" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="shareName" name="nameDialog" placeholder="" type="text") {{ shareName }}
      .label.share-description() Description (optional)
      textarea#shared-description(v-tooltip="{content: `<b>Description</b><br/>You can add any descriptive content you want to include here<br/>Youw ill be able to edit this content after saving/sharing` , classes: [ 'modaltip' ]}" v-model="shareDescription" autocomplete="off" autocorrect="off" autocapitalize="none" cols='31' rows='4' spellcheck="false" name="description" type="" required="" :placeholder="'Model Description (optional)'")
      el-switch#rerunSwitch(v-if="sharable" v-model="replay" :active-value="true" :inactive-value="false"  active-text="Allow Replay" inactive-text="" name="replay" v-tooltip="'Allow other users to rerun this model'")
  .vue-dialog-buttons(v-if='buttons')
    button(v-for='(button, i) in buttons' :class="button.class || 'vue-dialog-button'" type='button' :style='buttonStyle' :key='i' v-html='button.title' @click.stop='click(i, $event)')
      |{{button.title}}
  .vue-dialog-buttons-none(v-else='')
</template>
<script>
import strip from 'striptags'
import {
    Switch
} from 'element-ui'
export default {
  name: 'saveDialog',
  props: {
    clickToClose: {
      type: Boolean,
      default: true
    },
    transition: {
      type: String,
      default: 'fade'
    }
  },
  components: {
        [Switch.name]: Switch,
  },
  data () {
    return {
      params: {},
      sharable: false,
      shareDescription: '',
      shareName: '',
      replay: false,
      width: 600,
      defaultButtons: [{ title: 'CLOSE' }]
    }
  },
  mounted() {
    console.log("save dialog mounted");
    },
  computed: {
    buttons () {
      return this.params.buttons || this.defaultButtons
    },
    /**
      * Returns FLEX style with correct width for arbitrary number of
      * buttons.
      */
    buttonStyle () {
      return {
        flex: `1 1 ${100 / this.buttons.length}%`
      }
    }
  },
  methods: {
    beforeOpened (event) {
      window.addEventListener('keyup', this.onKeyUp)
      if (event.params) event.params.title = "Model Name (required)"
      this.params = event.params || {};
      let json = event.params && event.params.payload ? event.params.payload : {}
			let names = this.setNames(json)
      this.sharable = json.component && json.component == 'calculators' ? false : true;
      let calc = json.type == 'g25' || json.type == 'admix' ? true : false
      this.replay = json.replay || false;
      this.shareName = json.name && json.name.length >= 16 && ( json.modetype && json.name && json.name.toLowerCase().includes(json.modetype.toLowerCase())  || ( calc && ( json.name.toLowerCase().includes('calculator') || json.name.toLowerCase().includes('nmonte')))) ? json.name : json.hiddenTitle ? json.hiddenTitle : json.pcaTitle ? json.pcaTitle : names.hiddenTitle 
      this.shareDescription = json.content || ''
      this.$emit('before-opened', event)
    },
    updateThis (event) {
    console.log('updated')
    },
    beforeClosed (event) {
      window.removeEventListener('keyup', this.onKeyUp)
      this.params = {}
      this.$emit('before-closed', event)
    },
    click (i, event, source = 'click') {
      const button = this.buttons[i]

      if (button && typeof button.handler === 'function') {
        button.handler(i, event, { source })
      } else {
        this.$modal.hide('dialog')
      }
    },
    onKeyUp (event) {
      if (event.which === 13 && this.buttons.length > 0) {
        const buttonIndex =
          this.buttons.length === 1
            ? 0
            : this.buttons.findIndex(button => button.default)

        if (buttonIndex !== -1) {
          this.click(buttonIndex, event, 'keypress')
        }
      }
    },
	setNames(json) {
								let labelTitle;
                let type = json.type == 'g25' && json.switches && json.switches.calculator ? 'admix' : json.type
                let categories = json.categories;
                if (json.type == 'g25' || json.type == 'admix') {
                    if (json.type === 'admix') categories = json.categories.map(x => x = x.replace(/-raw/, ''))
                    let labelTarget = categories[json.index || 0]
                    let tempgroupArray = json.calcArray ? json.calcArray :  json.calcArrayLocal ? json.calcArrayLocal : json.groupArray
                    let tempcomponents = ''
                    if (json.components) {
                        if (json.components.length <= 16) {
                            tempcomponents = '<p>Components:<ul>' + json.components.map((x, i) => {
                                return (`<li>${x.replace(/_/g, ' ')}</li>`)
                            }).join('') + '</ul></p>'
                        } else {
                            tempcomponents = '<p>Components:<br>' + json.components.join(', ').replace(/_/g, ' ') + '</p>'
                        }
                    }
                    labelTitle = tempgroupArray.map(x => decodeURIComponent(x).replace(/_/g, ' '))
                    json.calculatorOwner = json.calculator ? json.calculator.split(':')[0] : false;
                    let calculator = json.calcArray ? json.calcArray[0] : json.calcArrayLocal ? json.calcArrayLocal[0] : json.calculator ? json.calculator.split(':')[1] : json.switches.calculator && json.groupArray && json.groupArray[0] ? json.groupArray[0] : false;
                    if (json.calculator || json.switches && json.switches.calculator) {
                        if (json.modetype || json.type == 'g25') {
                            json.hiddenTitle = `Calculator results for ${labelTarget} with the ` + decodeURIComponent(calculator) + ' ' + (json.modetype == 'G25' || json.type == 'g25' ? 'Global 25 Calculator' : json.modetype + ' Calculator')
                            labelTitle = `${json.modetype == 'G25' || json.type == 'g25' ? 'Global 25 (G25)' : json.modetype} nMonte results for ${labelTarget} with the ${decodeURIComponent(calculator)} ${json.modetype ? json.modetype : json.type == 'g25' ? 'G25' : ''} calculator${json.calculatorOwner ? ' by ' + json.calculatorOwner : ''}${tempcomponents ? '<br>' + tempcomponents : ''}${ json.modetype == 'G25' || json.type == 'g25' ? '<br>(G25 coordinates)' : ''}`
                        } else {
                            json.hiddenTitle = `Calculator results for ${labelTarget} with the ` + decodeURIComponent(calculator) + ' ' + (json.type == 'admix' ? 'GEDMatch Calculator / Admixture Calculator' : 'Calculator')
                            labelTitle = `Calculator results for ${labelTarget} with the ${decodeURIComponent(calculator)} ${json.type == 'admix' ? 'GEDMatch calculator / Admixture' :''} calculator${json.calculatorOwner ? ' by ' + json.calculatorOwner : ''}${tempcomponents ? '<br>' + tempcomponents : ''}${json.type == 'admix' ? '<br>(raw DNA upload of 23andMe/FTDNA/MyHeritage/LivingDNA files)' : ''}`
                        }
                    } else {
                        labelTitle = `${json.modetype == 'G25' || json.type == 'g25' ? 'Global 25 (G25)' : json.modetype} nMonte modeling results for ${labelTarget} with groups [${labelTitle.join(', ')}] (${json.modetype ? json.modetype : json.type == 'g25' ? 'G25' : 'admix'})`
                        json.hiddenTitle = `${json.modetype == 'G25' || json.type == 'g25' ? 'Global 25 (G25)' : 'admix'} nMonte modeling results for ${labelTarget}`
                    }
                } else {
                    let reference = json.reference && json.reference.length > 0 ? json.reference[0].replace(/:/, ' ► ') : false
                    let layout = json.layout
                    let groups = json.components.concat(json.samples)
                    groups = [...new Set(groups)]
                    let grouplen = 0;
                    groups = groups.map(x => {
                        if (x && x != 'undefined') {
                            if (grouplen < 200) {
                                return x.replace(/_/g, ' ')
                            }
                            grouplen = grouplen + x.length;
                        }
                    })
                    if (json.samples) groups = groups.concat(json.samples)
                    groups = groups.filter(x => x && x != 'undefined')
                    //json.hiddenLabel = layout.title ? `${layout.title.text.replace(/_/g, ' ')} with groups ${groups.join(', ').replace(/_/g, ' ')}...${ reference ? ' using reference sample ' + reference.replace(/_/g, ' ') : '' }` : ''
                    json.pcaTitle = layout && layout.title && layout.title.text && strip(layout.title.text).replace(/\&/g, '').replace(/\;/g, '').replace(/\</g, '').replace(/\>/g, '').length > 100 ? strip(layout.title.text).replace(/_/g, ' ') : (json.layout && json.layout.mode && json.layout.mode == '2d'  ? '2D' : '3D') + ` PCA with groups  ${groups.map( x => decodeURIComponent(x)).slice(0,5).filter( x => x && x != 'undefined').join(', ').slice(0,120)}...`
                    json.hiddenLabel = layout && layout.title && layout.title.text && strip(layout.title.text).replace(/\&/g, '').replace(/\;/g, '').replace(/\</g, '').replace(/\>/g, '').length > 100 ? `${strip(layout.title.text).replace(/_/g, ' ')} with groups ${groups.map( x => decodeURIComponent(x)).join(', ').replace(/_/g, ' ')}...${ reference ? ' using reference sample ' + reference.replace(/_/g, ' ') : '' }` : (json.layout && json.layout.mode && json.layout.mode == '2d' ? '2D' : '3D') + ` PCA with groups ${groups.map( x => decodeURIComponent(x)).join(', ').replace(/_/g, ' ')}...${ reference ? ' using reference sample ' + reference.replace(/_/g, ' ') : '' }`
                    labelTitle = json.hiddenLabel 
                }
					return {
					labelTitle: labelTitle,
          hiddenTitle: json.hiddenTitle,
					pcaTitle: json.pcaTitle,
					hiddenLabel: json.hiddenLabel
					}
		}
  }
}
</script>
<style>
.vue-dialog div {
  box-sizing: border-box;
}

.vue-dialog .dialog-flex {
  width: 100%;
  height: 100%;
}

.vue-dialog .dialog-content {
  flex: 1 0 auto;
  width: 100%;
  padding: 15px;
  font-size: 14px;
}

.vue-dialog .dialog-c-title {
  font-weight: 600;
  padding-bottom: 15px;
}

.vue-dialog .dialog-c-text {
}

.vue-dialog .vue-dialog-buttons {
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  border-top: 1px solid #eee;
}

.vue-dialog .vue-dialog-buttons-none {
  width: 100%;
  padding-bottom: 15px;
}

.vue-dialog-button {
  font-size: 12px !important;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 40px;
  height: 40px;
  color: inherit;
  font: inherit;
  outline: none;
}

.vue-dialog-button:hover {
  background: rgba(0, 0, 0, 0.01);
}

.vue-dialog-button:active {
  background: rgba(0, 0, 0, 0.025);
}

.vue-dialog-button:not(:first-of-type) {
  border-left: 1px solid #eee;
}
body #saveDialog {
    border: 1px solid rgba(0,0,0,0.2);
    box-shadow: none;
    outline: none;
    padding: 5px 8px;
    border-radius: 5px;
		top: 0;
    width: 100%;
    margin-bottom: 20px;
}
body #saveDialog::outline {
box-shadow: none;
}
body #saveDialog::-moz-selection {
background: #418fc5;
color: white;
outline: #418fc5;
}
body #saveDialog::selection {
background: #418fc5;
color: white;
outline: #418fc5;
}
#shared-description {
    width: 100%;
    padding: 10px;
    margin-bottom: 20px;
}
.label.share-description {
    font-weight: 600;
    padding-bottom: 15px;
}
</style>
